import React from 'react';
import BaseScadaNode from './BaseScadaNode';

export function LEDSVGIcon({ value, config = {}, size = 32 }) {
    const threshold = parseFloat(config.threshold ?? 0.5);
    const on = parseFloat(value) >= threshold;
    const onColor = config.on_color || '#22C55E';
    const offColor = config.off_color || '#334155';
    const color = on ? onColor : offColor;
    return (
        <svg width={size} height={size} viewBox="0 0 32 32" style={{ display: 'block' }}>
            {on && <circle cx={16} cy={16} r={14} fill={color} opacity={0.2} />}
            <circle cx={16} cy={16} r={10} fill={color} />
            <circle cx={12} cy={12} r={3} fill="rgba(255,255,255,0.3)" />
        </svg>
    );
}

export default function LEDIndicatorNode(props) {
    const { data } = props;
    const sz = Math.min(data?.width || 32, data?.height || 32);
    return (
        <BaseScadaNode {...props}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                <LEDSVGIcon value={data?.liveValue} config={data?.config} size={sz - 4} />
                {data?.label && (
                    <div style={{ fontSize: 10, color: '#94A3B8', marginTop: 2, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', maxWidth: '100%' }}>
                        {data.label}
                    </div>
                )}
            </div>
        </BaseScadaNode>
    );
}
